<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons *ngIf="!isFromBookings" slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-buttons *ngIf="isFromBookings" slot="start">
      <ion-back-button
        mode="md"
        (click)="close()"
      ></ion-back-button>
    </ion-buttons>
    <ion-title> {{ title }} </ion-title>
    <ion-buttons slot="end" *ngIf="!sale?.isRefundSale()">
      <ion-button (click)="showMoreOptions($event)">
        <ion-icon name="ellipsis-vertical"></ion-icon>
        <!-- <ion-icon name="chevron-down"></ion-icon> -->
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-button
    color="dark"
    fill="clear"
    icon-left
    (click)="changeDate()"
    class="datepicker-button"
    [disabled]="sale && sale.isRefundSale()"
  >
    <ion-icon name="calendar" style="padding-right: 10px"></ion-icon>
    {{sale.datetime | salonMonsterDate: 'ddd, MMMM D, Y h:mm a'}}
  </ion-button>
  <ion-buttons
    class="change-date"
    *ngIf="!isServiceDate && !sale.isRefundSale()"
  >
    <ion-button fill="clear" class="info-icon" id="hover-trigger">
      <ion-icon
        color="danger"
        name="information-circle"
      ></ion-icon>
    </ion-button>
    <ion-button fill="clear">
      <ion-label
        class="ion-text-wrap"
        (click)="changeToServiceDate()"
        color="danger"
        tappable
        >Change to service date
      </ion-label>
    </ion-button>
  </ion-buttons>

  <ion-popover trigger="hover-trigger" triggerAction="hover">
    <ng-template>
      <ion-content class="ion-padding">
        <span>
          Change the sale date to the original booking date and time
        </span>
        <br />
        <br />
        <b
          >{{ lineItemDateTime | salonMonsterDate: 'ddd, MMMM D, Y h:mm a' }}</b
        >
      </ion-content>
    </ng-template>
  </ion-popover>

  <ion-row>
    <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
      <smr-sale-client
        *ngFor="let client of sale.saleClients"
        [client]="client"
        [sale]="sale"
        (productAdd)="showProductPicker(client)"
        (serviceAdd)="showServicePicker(client)"
        (lineitemSelect)="editLineitem($event)"
      >
      </smr-sale-client>
      <div *ngIf="sale && !sale.isRefundSale()" class="ion-text-center ion-padding">
        <ion-button
          class="ion-margin-top ion-margin-bottom tertiary-button"
          size="small"
          (click)="addAppointment()"
        >
          + Appointment</ion-button
        >
      </div>
    </ion-col>
    <ion-col class="hidden-sm-down">
      <!-- (editTip)="editTip($event.tip, $event.tipIndex)"
          (editPayment)="editPayment($event.payment, $event.paymentIndex)"
          (addTip)="addTip()"
          (addPayment)="addPayment()" 
        These were in the smr tip payments manager but these functions don't exist here-->

      <smr-tips-payments-manager
        (saleUpdated)="onSaleUpdated($event)"
        [sale]="sale"
        [showButtons]="true"
        [isFromBookings]="isFromBookings"
        [isFromRegisterClosure]="isFromRegisterClosure"
      >
      </smr-tips-payments-manager>
    </ion-col>
  </ion-row>

  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
</ion-content>

<ion-footer
  class="ion-no-border ion-no-margin"
  *ngIf="!readOnly"
  class="hidden-md-up"
>
  <ion-toolbar>
    <smr-sale-total-summary [sale]="sale"> </smr-sale-total-summary>

    <ion-button
      *ngIf="!sale?.isRefundSale()"
      expand="block"
      color="primary"
      [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
      (click)="checkOutSale()"
    >
      Continue
    </ion-button>

    <ion-button
      *ngIf="sale && sale.isRefundSale()"
      expand="block"
      color="primary"
      [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
      (click)="selectRefundMethod()"
    >
      Continue
    </ion-button>
  </ion-toolbar>
</ion-footer>
